module.exports = __webpack_public_path__ + "static/media/anne.9ed48959.jpg";